import React, {useEffect, useState} from 'react';
import DataModelMenu from './Components/DataModelMenu';
import ModelFilter from '../../Components/ModelFilter';
import SubModelItem from './Components/SubModelItem';
import FieldItem from './Components/FieldItem';
import searchIcon from "../../../../../assests/img/search-icon.svg";
import { ALL, BOOLEAN, CATEGORY_NAME, CATEGORY_TYPE, CREATE_CATEGORY, CREATE_SUB_MODEL, DATA_MODEL, DECIMAL, EMPTY_FIELDS, FRACTION, INTEGER, MULTI_CHOICE, PRODUCT_CATEGORY, SUB_MODEL, SUB_MODEL_NAME, SUB_MODEL_TYPE, FIELD, TEXT_FIELD, CONNECTOR, CONNECTOR_NAME, TRANSFORMATION, CREATE_CONNECTOR, EXPAND_ALL, COLLAPSE_ALL, RANGE_FIELD } from '../../ISRConstants';
import CreateISRDialog from '../../Components/CreateISRDialog';
import BooleanField from './Components/BooleanField';
import CreateFieldDialog from '../../Components/CreateFieldDialog';
import { TConnector, TField, TIndexState, TProductCategory, TSubmodel, TTransformation, TUpsertISRProjectDataModelsInput } from './model';
import SubModelDetails from './Components/SubModelDetails';
import TextField from './Components/TextField';
import IntegerField from './Components/IntegerField';
import DecimalField from './Components/DecimalField';
import MultiChoiceField from './Components/MultiChoiceField';
import NoDataMessage from '../../Components/NoDataMessage';
import CategoryField from './Components/CategoryField';
import FractionalField from './Components/FractionalField';
import ConnectorField from './Components/ConnectorField';
import TransformationField from './Components/TransformationField';
import ProductCategoryItem from './Components/ProductCategoryItem';
import {toast} from "react-toastify";
import { useISRContext } from '../../Hooks/useISRContext';
import RangeField from "./Components/RangeField";

type TDefineModel = {
    id: string;
    userProjectDataModels: TUpsertISRProjectDataModelsInput;
    setUserProjectDataModels: React.Dispatch<React.SetStateAction<TUpsertISRProjectDataModelsInput>>;
    createISRProject: ()=>void;
}

const DefineModel = ({id, userProjectDataModels, setUserProjectDataModels, createISRProject}: TDefineModel) => {    
    const isrContext = useISRContext();
    const [searchInput, setSearchInput] = useState("");

    const [collapseAll, setCollapseAll] = useState<boolean>(false);
    const [selectedFilter, setSelectedFilter] = useState<string>(ALL);
    
    const [index, setIndex] = useState<TIndexState>({dataModelIndex: null,fieldIndex: null,fieldOutsideDataModelIndex: null,});
    const [selectedItem, setSelectedItem] = useState<TField | TSubmodel | TProductCategory | TConnector | null>(null);
    const [subSelectedItem, setSubSelectedItem] = useState<TTransformation| null>(null);
    const [showDialog, setShowDialog] = useState<boolean>(false);
    const [showCategoryDialog, setShowCategoryDialog] = useState<boolean>(false);
    const [showFieldDialog, setShowFieldDialog] = useState<boolean>(false);
    const [showConnectorDialog, setShowConnectorDialog] = useState<boolean>(false);

    useEffect(() => {
        if(index.dataModelIndex == null || index.dataModelIndex >= userProjectDataModels.project.dataModels.length) {
            return;
        }
        const subModel = userProjectDataModels.project.dataModels[index.dataModelIndex];
        if (index.categoryIndex != null && index.categoryIndex < subModel.data.productCategories.length) {
            setSelectedItem(subModel.data.productCategories[index.categoryIndex])
        } else if (index.fieldIndex != null && index.fieldIndex < subModel.data.fields.length) {
            setSelectedItem(subModel.data.fields[index.fieldIndex])
        }
    }, [userProjectDataModels]);

    const handleSearchInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchInput(event.target.value);
    };

    const openDialog = () => setShowDialog(true);
    const closeDialog = () => setShowDialog(false);
    
    const openFieldDialog = () => setShowFieldDialog(true);
    const closeFieldDialog = () => setShowFieldDialog(false);

    const openCategoryDialog = () => setShowCategoryDialog(true);
    const closeCategoryDialog = () => setShowCategoryDialog(false);

    const openConnectorDialog = () => setShowConnectorDialog(true);
    const closeConnectorDialog = () => setShowConnectorDialog(false);

    const onFieldSubmit = (fieldName: string, fieldType: string, calculated: boolean, filter: boolean) => {
        isrContext?.setUpdateLocalState(true);
        const newField: TField = { type: fieldType, name: fieldName, belongsToDataModel: false, dataConfiguration: {enableCalculation: calculated, filterAvailable: filter}, additionalData: {}, rules: [], };
        addField(newField);
    };

    const onConnectorFieldSubmit = (fieldName: string) => {
        isrContext?.setUpdateLocalState(true);
        const newField: TConnector = { type: "Connector", data: {type: "Connector", isConsumable: true, name: fieldName, belongsToDataModel: false ,  submodels: []} };
        addConnector(newField);
    };

    const addConnector = (newField: TConnector) => {
        setUserProjectDataModels((prevDataModels: TUpsertISRProjectDataModelsInput) => {
            if (!prevDataModels) {
                return prevDataModels;
            }
            if (prevDataModels.project) {                
                const updatedCategories = [
                    ...prevDataModels.project.connectors ?? [],
                    newField,
                ];
                return {
                ...prevDataModels,
                project: {
                    ...prevDataModels.project,
                    connectors: updatedCategories,
                },};
            }
        return prevDataModels;});
        createISRProject()
    };

    const onCategoryFieldSubmit = (fieldName: string) => {
        isrContext?.setUpdateLocalState(true);
        const newField: TProductCategory = { type: 'Category', data: {type: 'Category', name: fieldName, belongsToDataModel: false ,  categories: {type: '', data: []}, transformations:[], compatioScore:false, required: false} };
        addCategory(newField);
    };

    const addCategory = (newField: TProductCategory) => {
        setUserProjectDataModels((prevDataModels: TUpsertISRProjectDataModelsInput) => {
            if (!prevDataModels) {
                return prevDataModels;
            }
            if (prevDataModels.project) {
                const updatedCategories = [
                    ...prevDataModels.project.productCategories,
                    newField,
                ];
                return {
                ...prevDataModels,
                project: {
                    ...prevDataModels.project,
                    productCategories: updatedCategories,
                },};
            }
        return prevDataModels;});
        createISRProject()
    };

    const removeConnector = (connectorId: string|null|undefined) => {
        setUserProjectDataModels((prevDataModels: TUpsertISRProjectDataModelsInput) => {
            if (!prevDataModels || !prevDataModels.project) {
                return prevDataModels;
            }
            const updatedCategories = prevDataModels.project.connectors.filter(
                (connector) => connector?.id !== connectorId
            );
            return {
                ...prevDataModels,
                project: {
                ...prevDataModels.project,
                connectors: updatedCategories,
                },
            };
        });
    };

    const removeCategory = (categoryId: string|null|undefined) => {
        setUserProjectDataModels((prevDataModels: TUpsertISRProjectDataModelsInput) => {
            if (!prevDataModels || !prevDataModels.project) {
                return prevDataModels;
            }
            const updatedCategories = prevDataModels.project.productCategories.filter(
                (category) => category?.id !== categoryId
            );
            return {
                ...prevDataModels,
                project: {
                ...prevDataModels.project,
                productCategories: updatedCategories,
                },
            };
        });
    };

    const removeTransformation = (categoryId:string, transformationId: string) => {
        setUserProjectDataModels((prevDataModels: TUpsertISRProjectDataModelsInput) => {
            if (!prevDataModels || !prevDataModels.project) {
                return prevDataModels;
            }
            const updatedCategories = prevDataModels.project.productCategories.map(
                (category) => {
                    if(category.id === categoryId)
                    {
                        category.data.transformations = category?.data?.transformations?.filter(
                            transformation => 
                            transformation.id !== transformationId)
                    }
                    return category
                }
            );
            return {
                ...prevDataModels,
                project: {
                ...prevDataModels.project,
                productCategories: updatedCategories,
                },
            };
        });
    };

    const addField = (newField: TField) => {
        setUserProjectDataModels((prevDataModels: TUpsertISRProjectDataModelsInput) => {
            if (!prevDataModels) {
                return prevDataModels;
            }
    
            if (prevDataModels.project) {
                return { ...prevDataModels, project: { ...prevDataModels.project, fields: [...prevDataModels.project.fields, { type: newField.type, data: newField }], }, };
            }

            return prevDataModels;
        });
        createISRProject()
    };

    const removeField = (fieldId: string|null|undefined) => {
        setSelectedItem(null);
        setUserProjectDataModels((prevDataModels: TUpsertISRProjectDataModelsInput) => {
            if (!prevDataModels) {
                return prevDataModels;
            }
            if (prevDataModels.project) {
                return {...prevDataModels, project: { ...prevDataModels.project, fields: prevDataModels.project.fields.filter(field => field?.id !== fieldId), }, };
            }
            return prevDataModels;
        });
        
    };

    const onSubmodelFieldSubmit = (submodelName: string) => {
        if(userProjectDataModels.project.dataModels.filter(submodel => submodel.data.name.toLowerCase() === submodelName.toLowerCase()).length > 0) {
            toast.error("Submodel with same name exists");
            return;
        }
        isrContext?.setUpdateLocalState(true);
        const newSubmodel: TSubmodel = { type: "Submodel", data: { name: submodelName, fields: [], productCategories: [], connectors: [], required: false, minInstantiation: 1, maxInstantiation: 1 } }
        addSubmodel(newSubmodel);
    }

    const addSubmodel = (newSubmodel: TSubmodel) => {
        setUserProjectDataModels((prevDataModels: TUpsertISRProjectDataModelsInput) => {
            const newDataModels = { ...prevDataModels };
            if (newDataModels.project) {
                newDataModels.project.dataModels.push(newSubmodel);
            }
            return newDataModels as TUpsertISRProjectDataModelsInput;
        });
        createISRProject()
    };

    const removeSubmodel = (subModelId: string|null|undefined) => {
        setSelectedItem(null);
        setUserProjectDataModels((prevDataModels: TUpsertISRProjectDataModelsInput) => {
            if (!prevDataModels) {
                return prevDataModels;
            }
            if (prevDataModels.project) {
                return { ...prevDataModels, project: { ...prevDataModels.project, dataModels: prevDataModels.project.dataModels.filter(submodel => submodel?.id !== subModelId), }, };
            }
            return prevDataModels;
        });
        
    };

    const handleSubmodelSelect = (dataModelIndex: number) => {
        setIndex({ dataModelIndex, fieldIndex: null, fieldOutsideDataModelIndex: null });
    };

    const handleFieldOutsideDataModelSelect = (fieldOutsideDataModelIndex: number) => {
        setIndex({ dataModelIndex: null, fieldIndex: null, fieldOutsideDataModelIndex: fieldOutsideDataModelIndex, categoryOutsideDataModelIndex: fieldOutsideDataModelIndex });
    };

    const handleConnectorsOutsideDataModelSelect = (fieldOutsideDataModelIndex: number) => {
        setIndex({ dataModelIndex: null, fieldIndex: null, fieldOutsideDataModelIndex: null, categoryOutsideDataModelIndex: null, connectorOutsideDataModelIndex: fieldOutsideDataModelIndex });
    };

    const handleCollapseAllClick = () => {
        setCollapseAll((prev) => prev = !prev);
    }

    const filteredFields = searchInput?
        userProjectDataModels?.project?.fields
                .filter(field =>
                    field.data.name.toLowerCase().includes(searchInput.toLowerCase())
                )
        : userProjectDataModels?.project?.fields;

    const filteredCategories = searchInput?
        userProjectDataModels?.project?.productCategories
                .filter(category =>
                    category.data.name.toLowerCase().includes(searchInput.toLowerCase())
                )
        : userProjectDataModels?.project?.productCategories;

    const filteredConnectors = searchInput?
        userProjectDataModels?.project?.connectors
                .filter(connector =>
                    connector.data.name.toLowerCase().includes(searchInput.toLowerCase())
                )
        : userProjectDataModels?.project?.connectors;

    
        return (
            <React.Fragment>
                <div id={id} className="tw-flex tw-h-[calc(100vh-171px)]">
                    <div id={`${id}-sidebar`} className="tw-flex-grow tw-w-[30%] tw-max-h-full tw-py-2.5 tw-pe-2 tw-border-r tw-border-solid tw-border-[#E5E5EA] tw-overflow-y-auto">
                        <div id={`${id}-sidebar-header`} className='tw-flex tw-items-center tw-justify-between tw-gap-2 tw-mb-2'>
                            <label id={`${id}-model-label`} className='tw-text-[#090A42] tw-font-semibold tw-text-sm'>{DATA_MODEL}</label>
                            <div id={`${id}-model-menu`}>
                                <DataModelMenu onOpen={openDialog} openFieldDialog={openFieldDialog} openCategoryDialog={openCategoryDialog} openConnectorDialog={openConnectorDialog}/>
                            </div>
                        </div>
                        <ModelFilter 
                            id={`${id}-model-filter`}
                            labels={[ALL, SUB_MODEL, FIELD, PRODUCT_CATEGORY]} 
                            selectedFilter={selectedFilter} 
                            setSelectedFilter={(filter) => {setSearchInput(''); setSelectedFilter(filter);}} 
                        />
                        <div id={`${id}-search-section`} className='tw-flex tw-items-center tw-justify-between tw-gap-2 tw-mt-2'>
                            <div id={`${id}-search-container`} className='tw-flex tw-flex-grow tw-items-center tw-h-[32px] tw-p-2 tw-gap-3 tw-rounded-[4px] tw-border-[1px] tw-border-[#7676801F] tw-bg-white'>
                                <img id={`${id}-search-icon`} src={searchIcon} alt="Search Category" />
                                <input 
                                    id={`${id}-search-input`}
                                    value={searchInput} 
                                    onChange={handleSearchInputChange}  
                                    type="search" 
                                    placeholder={"Search"} 
                                    className='tw-w-full tw-text-[#747593] tw-font-normal focus:tw-outline-none tw-border-0 tw-text-xs tw-block tw-bg-transparent'
                                />
                            </div>
                            <button 
                                id={`${id}-collapse-btn`}
                                onClick={handleCollapseAllClick} 
                                className={`btn-outlined`}
                            >
                                {collapseAll ? EXPAND_ALL : COLLAPSE_ALL}
                            </button>
                        </div>
        
                        <div id={`${id}-submodels-list`}>
                            {(selectedFilter === ALL || selectedFilter === SUB_MODEL) && userProjectDataModels?.project?.dataModels.length > 0 ? userProjectDataModels?.project?.dataModels?.map((submodel, submodelIndex) => {
                                    const show = searchInput ? submodel.data.name.toLowerCase().includes(searchInput.toLowerCase()) ||
                                        submodel.data.fields.filter(field =>
                                            field.name.toLowerCase().includes(searchInput.toLowerCase())
                                        ).length > 0 ||
                                        submodel.data.productCategories.filter(category =>
                                            category.data.name.toLowerCase().includes(searchInput.toLowerCase())
                                        ).length > 0 ||
                                        submodel.data.connectors.filter(connector =>
                                            connector.data.name.toLowerCase().includes(searchInput.toLowerCase())
                                        ).length > 0 : true;
                                    if(!show) {
                                        return <></>;
                                    }
                                    return <SubModelItem
                                        id={`${id}-submodel-${submodelIndex}`}
                                        key={submodel?.id}
                                        searchInput={searchInput}
                                        submodel={submodel}
                                        onDeleteSubmodel={removeSubmodel}
                                        selectedItem={selectedItem}
                                        collapseAll={collapseAll}
                                        setSelectedItem={setSelectedItem}
                                        classColor={submodel?.data?.class?.colour ?? ''}
                                        setUserProjectDataModels={setUserProjectDataModels}
                                        setIndex={setIndex}
                                        indexInfo={index}
                                        submodelIndex={submodelIndex}
                                        userProjectDataModels={userProjectDataModels}
                                        onSelect={() => {
                                            handleSubmodelSelect(submodelIndex);
                                            setSelectedItem(submodel);
                                        }}
                                        isSelected={(submodel.id === selectedItem?.id)}
                                        setSubSelectedItem={setSubSelectedItem}
                                    />;
                                }
                            ) : null}
                        </div>
                        
                        <div id={`${id}-fields-list`}>
                            {(selectedFilter === ALL || selectedFilter === FIELD) && filteredFields.length > 0 ? filteredFields.map((field, fieldIndex) =>
                                <div id={`${id}-field-container-${fieldIndex}`} key={field?.id} className='tw-my-2'>
                                    <FieldItem
                                        id={`${id}-field-${fieldIndex}`}
                                        fieldName={field?.data?.name}
                                        fieldId={field?.id}
                                        fieldType={field?.type}
                                        showCalculatedField={field?.data?.dataConfiguration?.enableCalculation}
                                        classColor={field?.data?.dataConfiguration?.class?.colour ?? ''}
                                        onDelete={removeField}
                                        indexInfo={index}
                                        userProjectDataModels={userProjectDataModels}
                                        selectedItem={selectedItem}
                                        onSelect={() => {
                                            handleFieldOutsideDataModelSelect(fieldIndex)
                                            setSelectedItem(field.data);
                                            setSubSelectedItem(null)
                                        }} 
                                        isSelected={field.data === selectedItem} 
                                    />
                                </div>
                            ) : null}
                        </div>
        
                        <div id={`${id}-categories-list`}>
                            {(selectedFilter === ALL || selectedFilter === PRODUCT_CATEGORY) && filteredCategories.length > 0 ? filteredCategories.map((field, fieldIndex) => {
                                return (
                                    <div id={`${id}-category-container-${fieldIndex}`} key={field?.id} className='tw-my-2'>
                                        <ProductCategoryItem
                                            id={`${id}-category-${fieldIndex}`}
                                            field={field}
                                            fieldName={field?.data?.name}
                                            fieldType={field?.type}
                                            userProjectDataModels={userProjectDataModels}
                                            selectedItem={selectedItem}
                                            indexInfo={index}
                                            onDelete={removeCategory}
                                            onSubDelete={removeTransformation}
                                            onSelect={() => {
                                                handleFieldOutsideDataModelSelect(fieldIndex);
                                                setSelectedItem(field);
                                            }} 
                                            isSelected={field === selectedItem}
                                            setIndex={setIndex}
                                            setSubSelectedItem={setSubSelectedItem}
                                            setUserProjectDataModels={setUserProjectDataModels}
                                        />
                                    </div>
                                );
                            }) : null}
                        </div>
        
                        <div id={`${id}-connectors-list`}>
                            {userProjectDataModels?.project?.connectors && filteredConnectors.length > 0 ? filteredConnectors.map((field, fieldIndex) => {
                                return (
                                    <div id={`${id}-connector-container-${fieldIndex}`} key={field?.id} className='tw-my-2'>
                                        <FieldItem
                                            id={`${id}-connector-${fieldIndex}`}
                                            fieldName={field?.data?.name}
                                            fieldId={field?.id}
                                            fieldType={field?.type}
                                            userProjectDataModels={userProjectDataModels}
                                            selectedItem={selectedItem}
                                            indexInfo={index}
                                            onDelete={removeConnector}
                                            onSelect={() => {
                                                handleConnectorsOutsideDataModelSelect(fieldIndex);
                                                setSelectedItem(field);
                                                setSubSelectedItem(null)
                                            }} 
                                            isSelected={field === selectedItem} 
                                        />
                                    </div>
                                );
                            }) : null}
                        </div>
                    </div>
                    
                    <div id={`${id}-content`} className="tw-flex-grow tw-w-[70%] tw-max-h-full tw-py-4 tw-ps-4 tw-bg-[#f4f4f7] tw-overflow-y-auto">
                        {selectedItem && selectedItem?.type === SUB_MODEL_TYPE ? 
                            <SubModelDetails 
                                id={`${id}-submodel-details`}
                                key={selectedItem?.id ?? ''} 
                                selectedItem={selectedItem} 
                                setUserProjectDataModels={setUserProjectDataModels} 
                                indexInfo={index} 
                                projectId={userProjectDataModels?.project?.id ?? ''}
                            /> : null}
                        {selectedItem && (selectedItem?.type === TEXT_FIELD || selectedItem?.type === 'Field') ? 
                            <TextField 
                                id={`${id}-text-field-details`}
                                selectedItem={selectedItem} 
                                userProjectDataModels={userProjectDataModels} 
                                setUserProjectDataModels={setUserProjectDataModels}  
                                indexInfo={index} 
                                createISRProject={createISRProject}
                            /> : null}
                        {selectedItem && selectedItem?.type === INTEGER ? 
                            <IntegerField 
                                id={`${id}-integer-field-details`}
                                key={selectedItem?.id ?? ''} 
                                selectedItem={selectedItem} 
                                userProjectDataModels={userProjectDataModels} 
                                setUserProjectDataModels={setUserProjectDataModels} 
                                indexInfo={index} 
                                createISRProject={createISRProject}
                            /> : null}
                        {selectedItem && selectedItem?.type === DECIMAL ? 
                            <DecimalField 
                                id={`${id}-decimal-field-details`}
                                key={selectedItem?.id ?? ''} 
                                selectedItem={selectedItem} 
                                userProjectDataModels={userProjectDataModels} 
                                setUserProjectDataModels={setUserProjectDataModels} 
                                indexInfo={index} 
                                createISRProject={createISRProject}
                            /> : null}
                        {selectedItem && selectedItem?.type === BOOLEAN ? 
                            <BooleanField 
                                id={`${id}-boolean-field-details`}
                                selectedItem={selectedItem} 
                                userProjectDataModels={userProjectDataModels} 
                                setUserProjectDataModels={setUserProjectDataModels} 
                                indexInfo={index} 
                                createISRProject={createISRProject}
                            /> : null}
                        {selectedItem && selectedItem?.type === MULTI_CHOICE ? 
                            <MultiChoiceField 
                                id={`${id}-multi-choice-field-details`}
                                selectedItem={selectedItem} 
                                userProjectDataModels={userProjectDataModels} 
                                setUserProjectDataModels={setUserProjectDataModels} 
                                indexInfo={index}  
                                createISRProject={createISRProject}
                            /> : null}
                        {selectedItem && selectedItem?.type === RANGE_FIELD ?
                            <RangeField
                                id={`${id}-range-field-details`}
                                selectedItem={selectedItem}
                                userProjectDataModels={userProjectDataModels}
                                setUserProjectDataModels={setUserProjectDataModels}
                                indexInfo={index}
                                createISRProject={createISRProject}
                            /> : null}
                        {!subSelectedItem && selectedItem && selectedItem?.type === CATEGORY_TYPE ? 
                            <CategoryField 
                                id={`${id}-category-field-details`}
                                selectedItem={selectedItem} 
                                userProjectDataModels={userProjectDataModels}
                                setUserProjectDataModels={setUserProjectDataModels} 
                                indexInfo={index} 
                                setSubSelectedItem={setSubSelectedItem} 
                                setIndex={setIndex} 
                                createISRProject={createISRProject}
                            /> : null}
                        {selectedItem && selectedItem?.type === FRACTION ? 
                            <FractionalField 
                                id={`${id}-fraction-field-details`}
                                selectedItem={selectedItem} 
                                userProjectDataModels={userProjectDataModels} 
                                setUserProjectDataModels={setUserProjectDataModels} 
                                indexInfo={index} 
                                createISRProject={createISRProject}
                            /> : null}
                        {selectedItem && selectedItem?.type === 'Connector' ?
                            <ConnectorField 
                                id={`${id}-connector-field-details`}
                                selectedItem={selectedItem} 
                                userProjectDataModels={userProjectDataModels} 
                                setUserProjectDataModels={setUserProjectDataModels} 
                                indexInfo={index}
                            /> : null}
                        {subSelectedItem && subSelectedItem?.type === TRANSFORMATION && 
                            <TransformationField 
                                id={`${id}-transformation-field-details`}
                                selectedItem={selectedItem} 
                                userProjectDataModels={userProjectDataModels} 
                                setUserProjectDataModels={setUserProjectDataModels} 
                                indexInfo={index} 
                                subSelectedItem={subSelectedItem} 
                                createISRProject={createISRProject}
                            />}
                        {selectedItem === null ? 
                            <NoDataMessage 
                                id={`${id}-no-data`}
                                message={EMPTY_FIELDS}
                            /> : null}
                    </div>
                </div>
        
                {showDialog ? 
                    <CreateISRDialog 
                        id={`${id}-create-submodel-dialog`}
                        dialogHeader={CREATE_SUB_MODEL} 
                        labelName={SUB_MODEL_NAME} 
                        onClose={closeDialog} 
                        onSubmodelFieldSubmit={onSubmodelFieldSubmit}  
                    /> : null}
                {showCategoryDialog ? 
                    <CreateISRDialog 
                        id={`${id}-create-category-dialog`}
                        dialogHeader={CREATE_CATEGORY} 
                        labelName={CATEGORY_NAME} 
                        onClose={closeCategoryDialog} 
                        onSubmodelFieldSubmit={onCategoryFieldSubmit}  
                    /> : null}
                {showConnectorDialog ? 
                    <CreateISRDialog 
                        id={`${id}-create-connector-dialog`}
                        dialogHeader={CREATE_CONNECTOR} 
                        labelName={CONNECTOR_NAME} 
                        onClose={closeConnectorDialog} 
                        onSubmodelFieldSubmit={onConnectorFieldSubmit}  
                    /> : null}
                {showFieldDialog ? 
                    <CreateFieldDialog 
                        id={`${id}-create-field-dialog`}
                        onClose={closeFieldDialog} 
                        onFieldSubmit={onFieldSubmit} 
                    /> : null}
            </React.Fragment>
        );
}

export default DefineModel;